import React from 'react';
import { useRecordContext, useGetOne } from 'react-admin';
import { Box, Grid } from '@mui/material';
import { ProductBox, RuleList } from '../show';

export const GiftExpandableRow: React.FC = () => {
    const record = useRecordContext();

    // Mesma chain usada no show do brinde: é o `code` dela que monta o universal
    // link do QR Code / botão "Copiar link". Sem isso, o RuleList cai no fallback
    // e o botão copia o giftId cru em vez da URL completa.
    const { data: chain } = useGetOne(
        'chains',
        { id: record?.chainId },
        { enabled: !!record?.chainId },
    );

    if (!record) {
        return null;
    }

    return (
        <Box sx={{ p: 3, bgcolor: '#fafafa' }}>
            <Grid container spacing={2}>
                {/* Recompensas Section */}
                {record.giftProducts && record.giftProducts.length > 0 && (
                    <Grid size={12} sx={{ px: 2 }}>
                        <ProductBox />
                    </Grid>
                )}

                {/* Regras Section */}
                {record.giftRules && record.giftRules.length > 0 && (
                    <Grid size={12} sx={{ px: 2 }}>
                        <RuleList chain={chain} />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};
